var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-snackbar',{attrs:{"top":"","timeout":3000,"color":_vm.type},model:{value:(_vm.isVisible),callback:function ($$v) {_vm.isVisible=$$v},expression:"isVisible"}},[_vm._v(" "+_vm._s(_vm.$t(_vm.message))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }